import {Fragment, useEffect, useState} from "react";
import styles from "@/../sass/components/FlashMessage.module.scss";

export default function FlashMessage({type = 'info', message, autoClose = true, fixPosition = false, hasClosed = () => undefined}) {
    const [show, setShow] = useState(true);
    const [currentlyShowing, setCurrentlyShowing] = useState(true);
    useEffect(() => {
        setShow(true)
        setCurrentlyShowing(true)
        const autoCloseTimeout = autoClose ? setTimeout(() => handleClose(), 5000) : null;

        return () => clearTimeout(autoCloseTimeout)
    }, [message, type, autoClose])

    if (!show) {
        return <Fragment></Fragment>
    }
    return (
        <div className={`${styles.wrap} fade ${currentlyShowing ? styles.show : styles.hide} ${fixPosition ? styles.fixPosition : ""}`}>
            <div
                className={`${styles.flash} ${styles[type]}`}
            >
                <span className={styles.typeIcon}><i className={`fa ${iconClass(type)}`}></i></span>
                <span>{message}</span>
                <button
                    className={`btn btn-toolbar ${styles.closeIcon}`}
                    onClick={() => handleClose()}
                ><i className="fa fa-times"></i></button>
            </div>
        </div>
    );

    function handleClose() {
        setCurrentlyShowing(false)
        hasClosed()
    }

    function iconClass(type) {
        switch (type) {
            case 'success':
                return 'fa-check';
            case 'warning':
                return 'fa-exclamation-triangle';
            case 'danger':
                return 'fa-times-circle';
            case 'info':
                return 'fa-info-circle';
            default:
                return '';

        }
    }
}
